import React from 'react';
import PropsTypes from 'prop-types';

import {
  GlossaryComponent as Glossary,
} from '@learningblocks/storybook-components/lib/GlossaryComponent';
import { CloseButton } from '@learningblocks/shared-components/lib/CloseButton';
import {GlossaryDispatch} from '../index';

import style from './style.module.scss';

export function GlossaryMob(props) {
  const {state, onFetchGlossary, onFetchGlossaryItem} = React.useContext(
    GlossaryDispatch
  );

  const onSearch = (event) => {
    event.preventDefault();
    onFetchGlossary();
  };

  const isGlossaryEmpty = React.useMemo(() => {
    return state.glossaryList.length <= 0;
  }, [state.glossaryList.length]);

  const renderIndex = () => (
    <div className={style.glossary_index}>
      <div className={style.glossary_index_header}>
        <div className={style.glossary_index_header_headertop}>
          <Glossary.GlossaryLogo />
          <CloseButton
            close={props.closeGlossary}
            className={style.glossary_index_header_headertop_closeButton}
          />
        </div>
        <Glossary.SearchBox>
          <Glossary.SearchInput
            value={state.searchText}
            onEnterKey={onSearch}
          />
          <Glossary.SearchIcon onClick={onSearch} />
        </Glossary.SearchBox>
        <Glossary.CategoryDropdown categories={state.categories}>
          <Glossary.CategoryList list={state.categories} />
        </Glossary.CategoryDropdown>
      </div>
      <div className={style.glossary_index_body}>
        <Glossary.GlossaryListBlock
          {...state.listApi}
          onRetry={onSearch}
          isEmpty={isGlossaryEmpty}>
          <Glossary.GlossaryListing glossaryList={state.glossaryList} />
        </Glossary.GlossaryListBlock>
      </div>
    </div>
  );

  const renderDetailsBlock = () => (
    <div className={style.glossary_details}>
      <div className={style.glossary_details_header_headertop}>
        <Glossary.GlossaryLogo />
        <CloseButton
          close={props.closeGlossary}
          className={style.glossary_details_header_headertop_closeButton}
        />
      </div>
      <Glossary.MobileIndexBlock />
      <div className={style.glossary_details_content}>
        <Glossary.DetailsBlock
          {...state.contentApi}
          onRetry={()=>onFetchGlossaryItem(state.selected)}>
          <Glossary.GlossaryDetails {...state.glossaryItem} />
        </Glossary.DetailsBlock>
      </div>
    </div>
  );

  const renderGlossaryMob = () =>
    state.indexCollapsed ? renderDetailsBlock() : renderIndex();

  return <div className={style.glossary}>{renderGlossaryMob()}</div>;
}

GlossaryMob.propsTypes = {
  /**
   * function to close glossary modal window
   */
  closeGlossary: PropsTypes.func,
};
